import api from "APP_ROOT/api";
import { reset } from "redux-form";
import { SUCCESS } from "LIB/submission/constants";
import pagination from "./pagination";

export function update(commissionId, data) {
  return dispatch =>
    api.commissions.update(commissionId, data).then(() => {
      dispatch(pagination.pageActions.expire());
      dispatch(reset("updateCommissionForm"));
      return SUCCESS;
    });
}

export function searchCommissions(filters = {}) {
  return () => api.commissions.search(filters).then(resp => resp.data.results);
}

export function payAllCommissions(data = {}) {
  return dispatch =>
    api.commissions.payAll(data).then(() => {
      dispatch(pagination.pageActions.expire());
      return SUCCESS;
    });
}

export function toggleLock(commission) {
  const serializedUser = JSON.parse(window.localStorage.getItem("user"));
  const data = {
    locked: !commission.locked,
    locked_audit: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        full_name: serializedUser.full_name
      }
    }
  };

  return pagination.pageActions.updateAsync(
    commission.id,
    data,
    api.commissions.update(commission.id, data)
  );
}



// WEBPACK FOOTER //
// ./app/modules/Commissions/actions.js